import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Icon from 'components/common/Icon/Icon'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import VehicleImage from 'components/common/VehicleImage'
import { ReadMore } from 'components/common/ReadMore'
import { DEFAULT_VEHICLE_ASSET } from 'constant'
import { ButtonWrapper, Logo, Name } from '../sharedComponents'

const VehicleTile = ({
  className,
  asset = DEFAULT_VEHICLE_ASSET,
  active,
  modelWithoutYear,
  masterVehicle: {
    yearDesc: year,
    makeDesc: make,
    modelDesc: model,
    subModelDesc: submodel
  },
  color,
  ...props
}) =>
  <ButtonWrapper
    { ...props }
    type="button"
    data-at-appointment-vehicletile
    className={ className }
    active={ active }
    aria-selected={ active }
    aria-label={ !active ? `select ${modelWithoutYear}` : `${modelWithoutYear} is selected vehicle` }>
    <Media.NonScreenReader>
      <ContentWrapper>
        <Checked data-at-appointment-vehicletile-selected={ active } asset="check-circle" hidden={ !active } />
        <Logo data-at-appointment-vehicletile-logo>
          <Car
            make={ make }
            model={ model }
            submodel={ submodel }
            year={ parseInt(year, 10) }
            height={ 65 }
            width={ 130 }
            mobileHeight={ 40 }
            mobileWidth={ 80 }
            color={ color ? `#${color}` : undefined } />
        </Logo>
        <Year data-at-appointment-vehicletile-year>{ year }</Year>
        <Name data-at-appointment-vehicletile-name title={ modelWithoutYear }>
          <Media.Desktop>
            <ReadMore
              content={ modelWithoutYear }
              enableReadMore={ false }
              limit={ 42 } />
          </Media.Desktop>
          <Media.Mobile>
            <ReadMore
              content={ modelWithoutYear }
              enableReadMore={ false }
              limit={ 42 } />
          </Media.Mobile>
        </Name>
      </ContentWrapper>
    </Media.NonScreenReader>
  </ButtonWrapper>

VehicleTile.propTypes = {
  active: PropTypes.bool,
  asset: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string,
  make: PropTypes.string,
  masterVehicle: PropTypes.shape({
    yearDesc: PropTypes.string,
    makeDesc: PropTypes.string,
    modelDesc: PropTypes.string,
    subModelDesc: PropTypes.string
  }),
  model: PropTypes.string,
  modelWithoutYear: PropTypes.string,
  onClick: PropTypes.func,
  submodel: PropTypes.string,
  year: PropTypes.string
}

export default VehicleTile

const Checked = styled(Icon)`
  position: absolute;
  ${Mixin.responsive('right', '15px', '15px')}
  ${Mixin.responsive('top', '8px', '8px')}
`

const Car = styled(VehicleImage)`
  display: inline-block;
  vertical-align: middle;
  max-width: 100%;
  ${Mixin.responsive('max-height', '103px', '68px')}
`

const Year = styled.div`
  ${Mixin.responsive('font-size', '14px', '10px')}
`

const ContentWrapper = styled.span`
  overflow: hidden;
  display: block;
  ${Mixin.responsive('height', '110%', '100%')}
`
